// Decides what renders inside the always-visible "Create with AI" tab. No BE availability query
// yet, so the gate is inferred from the app.aiAssistant flag: on → wizard, off → upsell.

import { useAuth } from 'src/state/auth';
import { RiskIntelGateState } from './types';

export const useRiskIntelGate = (): RiskIntelGateState => {
  const { features } = useAuth();
  return features['app.aiAssistant'] ? 'enabled' : 'locked';
};
